import React from 'react';

interface BrowserFrameProps {
  url?: string;
  children: React.ReactNode;
  className?: string;
}

const BrowserFrame: React.FC<BrowserFrameProps> = ({
  url = 'app.lanerunner.com',
  children,
  className = '',
}) => {
  return (
    <div
      className={`rounded-2xl overflow-hidden bg-white border border-gray-200 shadow-2xl ${className}`}
    >
      <div className="flex items-center gap-2 px-4 py-2.5 bg-gray-100 border-b border-gray-200">
        <span className="h-2.5 w-2.5 rounded-full bg-[#ff5f57]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#febc2e]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#28c840]" />
        <div className="flex-1 mx-3 px-3 py-1 rounded-md bg-white border border-gray-200 text-[11px] text-gray-500 font-mono truncate">
          {url}
        </div>
      </div>
      <div className="bg-gradient-to-br from-white to-gray-50">{children}</div>
    </div>
  );
};

export default BrowserFrame;
